<template>
  <div class="component-progress-bar">
    <div :style="progressStyle" class="component-progress-bar__progress"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressWidth() {
      return this.progress * 100 + '%'
    },
    progressStyle() {
      return `width: ${this.progressWidth};`
    }
  }
}
</script>

<style scoped lang="scss">
.component-progress-bar {
  &__progress {
    height: 2px;
    background: $blue-900;
    transition: width 450ms ease;
  }
}
</style>
